import { TRIP_TYPE_CODES } from './tripTypes';

/**
 * Trip types that are subject to a member's coverage trip limit. Ancillary services
 * (meals, lodging, flights, parking, tolls) are supplemental reimbursements rather
 * than transportation trips, so they are excluded from coverage trip-limit counting.
 */
export const COVERAGE_LIMITED_TRIP_TYPE_CODES = Object.freeze([
  TRIP_TYPE_CODES.SCHEDULED,
  TRIP_TYPE_CODES.MILEAGE_REIMBURSEMENT,
  TRIP_TYPE_CODES.PUBLIC_TRANSPORTATION,
]);
